var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.223,
    height: 19.237,
    viewBox: "0 0 19.223 19.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#479ed5;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.195,3.33a.86.86,0,0,1-.034.1.755.755,0,0,1-.043.124.735.735,0,0,1-.1.157.809.809,0,0,1-.046.07l-8.011,8.006c-.014.014-.032.019-.046.031a1.115,1.115,0,0,1-.277.157c-.018.006-.031.019-.049.023l-3.205.8a.792.792,0,0,1-.194.024.8.8,0,0,1-.778-1l.8-3.2c0-.019.018-.032.024-.049A.788.788,0,0,1,7.3,8.431.769.769,0,0,1,7.389,8.3c.012-.015.017-.033.031-.047L15.431.247A.691.691,0,0,1,15.51.2a.768.768,0,0,1,.135-.09A.731.731,0,0,1,15.8.052a.646.646,0,0,1,.086-.031,3.174,3.174,0,0,1,2.6.78A3.268,3.268,0,0,1,19.195,3.33ZM17.318,1.895a1.405,1.405,0,0,0-.968-.3L8.71,9.229l-.424,1.693L9.981,10.5l7.639-7.634A1.5,1.5,0,0,0,17.318,1.895ZM9.7,3.08H1.617l-.04,14.548,14.59,0V9.546a.808.808,0,1,1,1.617,0v8.892c0,.442-.542.791-.985.791H.776A.771.771,0,0,1,0,18.438V2.271a.814.814,0,0,1,.808-.808H9.7a.808.808,0,0,1,0,1.617Z",
    transform: "translate(0 0.009)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/edit-blue.44e0a510f60a8ad4d38252eed54f7f1c.svg";
export { ForwardRef as ReactComponent };